//
//
//
//
//
//


import { AuthListener } from '@/mixins/AuthListener';

export default {
   name: 'App',
   mixins: [AuthListener],
   onAuthed() {
      this.$store.dispatch('metadata/fetchMetadata');
   },
   watch: {
      '$route.meta': {
         immediate: true,
         handler: function(meta) {
            if (meta.title && meta.title !== this.toolbarTitle) {
               this.$store.commit('ui/setToolbarTitle', meta.title);
            }
         },
      },
      '$store.state.ui.toolbarTitle': {
         immediate: true,
         handler: function(title) {
            document.title = title || '';
         },
      },
   },
   mounted() {
      if (process.env.NODE_ENV === 'development') {
         window.app = this;
      }
   },
   created() {
      // Register custom icons
      // eslint-disable-next-line
      this.$q.iconMapFn = (iconName) => {
         if ([
            'agriculture',
            'board',
            'building',
            'car',
            'housing',
            'illness_accidents',
            'liability',
            'machines',
            'netbank',
            'operatingloss',
            'product',
            'rejse',
            'responsibility',
            'trailer',
            'transport',
            'ulykke',
         ].indexOf(iconName) !== -1) {
            return {
               cls: `product-icon business icon-${iconName}`,
            };
         }
      };
   },
};
